import {
  ArrowRight,
  ArrowUpRight,
  Award,
  BadgeCheck,
  BookOpen,
  ChevronRight,
  CircleDollarSign,
  Clapperboard,
  Clock3,
  FileText,
  Gift,
  Globe2,
  Layers,
  MapPin,
  MessageCircle,
  Play,
  Sparkles,
  UserRound,
  UsersRound,
  Video,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

const icons: Record<string, LucideIcon> = {
  'arrow-right': ArrowRight,
  'arrow-up-right': ArrowUpRight,
  award: Award,
  'badge-check': BadgeCheck,
  'book-open': BookOpen,
  'chevron-right': ChevronRight,
  'circle-dollar-sign': CircleDollarSign,
  'clapperboard': Clapperboard,
  'clock-3': Clock3,
  'file-text': FileText,
  gift: Gift,
  'globe-2': Globe2,
  layers: Layers,
  'map-pin': MapPin,
  'message-circle': MessageCircle,
  play: Play,
  sparkles: Sparkles,
  'user-round': UserRound,
  'users-round': UsersRound,
  video: Video,
}

interface HomeIconProps {
  name: string
  size?: number
  className?: string
}

export default function HomeIcon({ name, size = 18, className }: HomeIconProps) {
  const Icon = icons[name] ?? FileText
  return <Icon size={size} className={className} />
}
